import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        addressLine1: {
            minWidth: theme.spacing(20),
        },
        archived: {
            minWidth: theme.spacing(10),
        },
    }
})
